(() => {
  "use strict";
  if (window.OrtluxPages) {
    window.OrtluxPages.init(document);
    return;
  }
  const normalize = (value) =>
    String(value)
      .normalize("NFKD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLocaleLowerCase("de")
      .trim();
  function init(root) {
    root.querySelectorAll("[data-ox-root]").forEach((section) => {
      if (section.dataset.oxReady) return;
      section.dataset.oxReady = "true";
      section.querySelectorAll("[data-ox-enhanced]").forEach((el) => {
        el.hidden = false;
      });
      const list = section.querySelector("[data-ox-items]");
      if (list) {
        const items = [...list.querySelectorAll("[data-ox-item]")];
        const search = section.querySelector("[data-ox-search]");
        const sort = section.querySelector("[data-ox-sort]");
        const isBrand = section.hasAttribute("data-ox-brands");
        const buttons = [...section.querySelectorAll("[data-ox-category]")];
        let category = "all";
        function update() {
          const query = normalize(search?.value || "");
          let count = 0;
          items.forEach((item) => {
            const matchCategory =
              category === "all" || (item.dataset.category || "").split(" ").includes(category);
            const matchText = normalize(isBrand ? item.dataset.name : item.textContent).includes(query);
            item.hidden = !(matchCategory && matchText);
            if (!item.hidden) count++;
          });
          const ordered = [...items];
          if (sort && sort.value !== "featured")
            ordered.sort(
              (a, b) => a.dataset.name.localeCompare(b.dataset.name, "de") * (sort.value === "za" ? -1 : 1),
            );
          ordered.forEach((item) => list.append(item));
          const status = section.querySelector("[data-ox-count]");
          if (status)
            status.textContent = isBrand
              ? `${count} ${count === 1 ? "brand" : "brands"} to explore`
              : `${count} ${count === 1 ? "answer" : "answers"} found`;
          const empty = section.querySelector("[data-ox-empty]");
          if (empty) empty.hidden = count !== 0;
          buttons.forEach((button) => {
            const active = category === button.dataset.oxCategory;
            button.classList.toggle("is-active", active);
            button.setAttribute("aria-pressed", String(active));
          });
        }
        buttons.forEach((button) =>
          button.addEventListener("click", () => {
            category = button.dataset.oxCategory;
            update();
          }),
        );
        search?.addEventListener("input", update);
        sort?.addEventListener("change", update);
        section.querySelectorAll("[data-ox-reset]").forEach((button) =>
          button.addEventListener("click", () => {
            category = "all";
            if (search) search.value = "";
            if (sort) sort.value = "featured";
            update();
            search?.focus({ preventScroll: true });
          }),
        );
        update();
      }
      const toc = section.querySelector("[data-ox-toc]");
      const article = section.querySelector("[data-ox-document]");
      if (toc && article) {
        article.querySelectorAll("h2").forEach((heading, index) => {
          if (!heading.id) heading.id = `ox-${section.closest("[id]")?.id || "document"}-${index + 1}`;
          const link = document.createElement("a");
          link.href = `#${heading.id}`;
          link.textContent = heading.textContent;
          toc.append(link);
        });
        if (!toc.children.length) toc.closest("aside").querySelector(".ox-eyebrow").hidden = true;
      }
      section.querySelector("[data-ox-form-status]")?.focus({ preventScroll: false });
    });
  }
  window.OrtluxPages = { init };
  document.addEventListener("shopify:section:load", (event) => init(event.target));
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => init(document));
  else init(document);
})();

// ortlux-editor-select: keep the selected block visible without affecting storefront browsing.
document.addEventListener("shopify:block:select", (event) => {
  const block = event.target;
  block.hidden = false;
  const details = block.matches?.("details") ? block : block.closest?.("details");
  if (details) details.open = true;
  const header = block.closest?.(".commerce-shell");
  header?.dispatchEvent(new Event("header:interaction"));
});
